import { render } from "./JobMemberCard.vue?vue&type=template&id=24aa94a6&scoped=true"
import script from "./JobMemberCard.vue?vue&type=script&lang=js"
export * from "./JobMemberCard.vue?vue&type=script&lang=js"

import "./JobMemberCard.vue?vue&type=style&index=0&id=24aa94a6&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24aa94a6"]])

export default __exports__